/**
 * Content types
 */

export const CONTENT_TYPES = {
  APPLICATION_JSON: 'application/json',
  MULTIPART_FORMDATA: 'multipart/form-data',
  URLENCODED: 'application/x-www-form-urlencoded',
};

export const PASSWORD_PATTERN =
  /^(?=.*[A-Z]+)(?=.*[a-z]+)(?=.*[0-9]+)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,50}$/;
// /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#&^()_+])[A-Za-z\d@$!%*#&^()_+]{8,}$/;

export const AT_LEAST_8_CHAR_PATTERN = /^.{8,50}$/;

export const INCLUDE_SPECIAL_CHAR_PATTERN = /[!@#$%^&*()_+]/;

export const SPECIAL_CHAR_PATTERN = /^[A-Za-z0-9!@#$%^&*()_+]+$/;

export const EMAIL_PATTERN = /^[\w+-]+(\.[\w+-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;

export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const DATE_PATTERN_YYYY_MM_DD =
  /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/;

export const DATE_PATTERN_MM_DD_YYYY =
  /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;

export const DATE_PATTERN_YYYY_MM_DD_TIME =
  /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01]) (\d{2}):(\d{2}):(\d{2})$/;

export const DATE_PATTERN_MM_DD_YYYY_TIME =
  /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4} (\d{2}):(\d{2}):(\d{2})$/;

export const DATE_PATTERN_MM_DD_YYYY_TIME_HOUR =
  /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4} (\d{1,2}):(\d{2}) (AM|PM)$/i;

export const NAME_PATTERN = /^[\p{L}\p{M}'\-\.\s,]{2,25}$/u;


// Simplified route matcher used in side navigation and link parsers
// Matches: /apps/:id(/...)? | /auth/(login|register|reset)(/:id)? | /user/profile | /company | /clients
export const APP_ROUTE_PATTERN = /^(?:\/?(?:apps\/[^\/]+|auth\/(?:login|register|reset)(?:\/[^\/]+)?|user\/profile|company|clients)(?:\/.*)?$)/;

export const DROPDOWN_VALUE_PLACEHOLDER = '-- Select --'

export const CUSTOM_PLACE_HOLDER = '-- Select an Option --'

export const NO_OPTION_TO_SELECT = "-- No Options Available --"

export const SELECT_LOADER = "-- Select -- ⏳"


//Action column collapse threshold
export const ACTION_WIDTH_THRESHOLD_PX = 292;
